import Network from 'lib/api/network';

export default {
  namespaced: true,

  state() {
    return {
      program: null,
    };
  },

  mutations: {
    updateProgramKey(state, { key, value }) {
      state.program[key] = value;
    },
  },

  actions: {
    updateRewardsProgram({ commit, dispatch }, { key, value }) {
      commit('update', { key: 'formSubmitted', value: true }, { root: true });

      return new Promise((resolve, reject) => {
        Network.put(
          '/rewards/settings',
          { rewards_program: { [key]: value } },
          {
            success: (updatedProgram) => {
              commit('updateProgramKey', { key, value: updatedProgram[key] });
              dispatch('setSuccessToast', 'Your changes have been saved.', { root: true });
              resolve(updatedProgram);
            },
            error: (response) => {
              const toastText = response.responseJSON?.displayError; // Can be null.
              dispatch('setErrorToast', toastText, { root: true });
              resolve();
            },
            complete: () => {
              commit('update', { key: 'formSubmitted', value: false }, { root: true });
            },
          },
        );
      });
    },

    saveFulfillmentChannel({ state, commit, dispatch }, { fulfillmentChannelId }) {
      commit('update', { key: 'formSubmitted', value: true }, { root: true });
      return new Promise((resolve, reject) => {
        Network.put(
          '/rewards/settings',
          { rewards_program: { redemption_fulfillment_channel_id: fulfillmentChannelId } },
          {
            success: (updatedProgram) => {
              commit('updateProgramKey', {
                key: 'redemption_fulfillment_channel_id',
                value: updatedProgram.redemption_fulfillment_channel_id,
              });
              dispatch('setSuccessToast', 'Fulfillment notification channel saved!', { root: true });
              window.donut.track('Rewards Program - Saved Fulfillment Channel');
              resolve(updatedProgram);
            },
            error: (response) => {
              const toastText = response.responseJSON?.displayError; // Can be null.
              dispatch('setErrorToast', toastText, { root: true });
              resolve();
            },
            complete: () => {
              commit('update', { key: 'formSubmitted', value: false }, { root: true });
            },
          },
        );
      });
    },
  },
};
